import { Component, forwardRef, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export type RadioButtonGroupItem = {
  key: string;          // valor que escriurem al form control
  label?: string;       // si vols text per defecte
  disabled?: boolean;   // item deshabilitat
};

@Component({
  selector: 'lib-radio-button-group',
  standalone: true,
  imports: [
    CommonModule,
  ],
    providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioButtonGroupComponent),
      multi: true,
    },
  ],
  templateUrl: './radio-button-group.component.html',
  styles: ``
})
export class RadioButtonGroupComponent implements ControlValueAccessor {

  items = input<RadioButtonGroupItem[]>([]);
  canSelect = input<(next: string, previous: string) => boolean>(() => true);

  // Valor seleccionat (binding amb Angular Forms)
  activeItem: string | null = null;

  // Disabled global (FormControl.disable())
  isDisabled = false;

  private onChange: (value: string | null) => void = () => {};
  private onTouched: () => void = () => {};

  setActiveItem(key: string) {
    if (this.isDisabled) return;

    const item = this.items().find(i => i.key === key);
    if (!item || item.disabled) return;

    let previous = this.activeItem;
    
    if(!previous || !this.canSelect()(key, previous)) {
      return;
    }

    this.activeItem = key;
    this.onChange(this.activeItem);
    this.onTouched();
  }

  // ControlValueAccessor
  writeValue(value: string | null): void {
    this.activeItem = value;
  }

  registerOnChange(fn: (value: string | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
}
